import { render, staticRenderFns } from "./NewAssetModal.vue?vue&type=template&id=5d273af0&scoped=true&"
import script from "./NewAssetModal.vue?vue&type=script&lang=ts&"
export * from "./NewAssetModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d273af0",
  null
  
)

export default component.exports